import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Injector } from '@angular/core';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotificationType } from 'src/core/decorators/notification/notification-type.decorator';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { NotificationService } from 'src/core/services/notification/notification.service';
import { CAToasterHelperService } from 'src/core/services/toaster/ca-toaster-helper.service';
import { CADatePipe } from 'src/core/pipes/ca-date.pipe';

@Component({
  selector: 'ca-statistical-comparison-result-ready-notification',
  templateUrl: './statistical-comparison-result-ready-notification.component.html',
  styleUrls: ['./statistical-comparison-result-ready-notification.component.scss'],
  standalone: false,
})
@NotificationType(
  'StatisticalComparisonResultReadyNotification',
  StatisticalComparisonResultReadyNotificationComponent,
)
export class StatisticalComparisonResultReadyNotificationComponent {
  data: NotificationDto;

  get payloadData(): any {
    return JSON.parse(this.data?.payload);
  }

  constructor(
    private notificationService: NotificationService,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  navigate() {
    const parsedPayload = JSON.parse(this.data.payload);

    if (parsedPayload.comparisonEnabled) {
      this.router.navigate(['/analysis', 'statistic-comparison', 'result', parsedPayload.resultId]);
    } else {
      this.router.navigate(['/analysis', 'statistic-analysis', 'result', parsedPayload.resultId]);
    }

    this.notificationService.getReadStatus(this.data.id).subscribe(result => {
      if (!result) {
        this.notificationService.markAsRead(this.data.id).subscribe();
      }
    });
  }

  static showNotification(
    notificationId: string,
    payload: string,
    toastr: ToasterService,
    localizationService: LocalizationService,
    toasterHelperService: CAToasterHelperService,
    notificationService: NotificationService,
    injector: Injector,
    caDatePipe: CADatePipe,
    router: Router,
  ) {
    const parsedPayload = JSON.parse(payload);
    const message = localizationService.instant(
      parsedPayload.comparisonEnabled
        ? 'Analysis::StatisticComparison:Result:Comparison:ReadyNotification'
        : 'Analysis::StatisticComparison:Result:Analysis:ReadyNotification',
    );

    const toastrId = toastr.success(message);

    const toastrInstance = toasterHelperService.getToastById(toastrId);
    toastrInstance.onTap.pipe(take(1)).subscribe(() => {
      this.toasterClickedHandler(
        notificationService,
        notificationId,
        parsedPayload.comparisonEnabled,
        parsedPayload.resultId,
        router,
      );
    });
  }

  static toasterClickedHandler(
    notificationService: NotificationService,
    notificationId: string,
    comparisonEnabled: boolean,
    resultId: string,
    router: Router,
  ) {
    if (comparisonEnabled) {
      router.navigate(['/analysis', 'statistic-comparison', 'result', resultId]);
    } else {
      router.navigate(['/analysis', 'statistic-analysis', 'result', resultId]);
    }

    notificationService.markAsRead(notificationId).subscribe();
  }
}
